import env from '../helpers/env';
import hasOpenTokSupportHelpers from '../helpers/hasOpenTokSupport';

const hasOpenTokSupport = hasOpenTokSupportHelpers.once;

export default () => hasOpenTokSupport() &&
  (env.isChromiumEdge || ['Chrome', 'Samsung', 'Safari', 'Firefox', 'Opera', 'iOS_WebView', 'Android_WebView'].includes(env.name));
